import React, { Component } from 'react';
import * as _ from 'lodash';
import Validator from 'validatorjs';
import { Form } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import CatalogoPais from '../../../catalogs/options/CatalogoPais';
import { RegimenFiscalCatalog } from '../../../../support/catalogs';
import { UsoDeCfdiCatalog } from '../../../../support/catalogs/UsoCfdiCatalog';

class ReceptorFiscalInfoForm extends Component {
  state = {}

  constructor(props) {
    super(props);

    const validator = new Validator({}, this.rules);

    this.state = {
      validator,
    };
  }

  get rules() {
    return {
      razon_social: [
        'required',
        'min:2',
        'max:250'
      ],
      residencia_fiscal: [
        'in:AFG,ALA,ALB,DEU,AND,AGO,AIA,ATA,ATG,SAU,DZA,ARG,ARM,ABW,AUS,AUT,AZE,BHS,BGD,BRB,BHR,BEL,BLZ,BEN,BMU,BLR,MMR,BOL,BIH,BWA,BRA,BRN,BGR,BFA,BDI,BTN,CPV,KHM,CMR,CAN,QAT,BES,TCD,CHL,CHN,CYP,COL,COM,PRK,KOR,CIV,CRI,HRV,CUB,CUW,DNK,DMA,ECU,EGY,SLV,ARE,ERI,SVK,SVN,ESP,USA,EST,ETH,PHL,FIN,FJI,FRA,GAB,GMB,GEO,GHA,GIB,GRD,GRC,GRL,GLP,GUM,GTM,GUF,GGY,GIN,GNB,GNQ,GUY,HTI,HND,HKG,HUN,IND,IDN,IRQ,IRN,IRL,BVT,IMN,CXR,NFK,ISL,CYM,CCK,COK,FRO,SGS,HMD,FLK,MNP,MHL,PCN,SLB,TCA,UMI,VGB,VIR,ISR,ITA,JAM,JPN,JEY,JOR,KAZ,KEN,KGZ,KIR,KWT,LAO,LSO,LVA,LBN,LBR,LBY,LIE,LTU,LUX,MAC,MDG,MYS,MWI,MDV,MLI,MLT,MAR,MTQ,MUS,MRT,MYT,MEX,FSM,MDA,MCO,MNG,MNE,MSR,MOZ,NAM,NRU,NPL,NIC,NER,NGA,NIU,NOR,NCL,NZL,OMN,NLD,PAK,PLW,PSE,PAN,PNG,PRY,PER,PYF,POL,PRT,PRI,GBR,CAF,CZE,MKD,COG,COD,DOM,REU,RWA,ROU,RUS,ESH,WSM,ASM,BLM,KNA,SMR,MAF,SPM,VCT,SHN,LCA,STP,SEN,SRB,SYC,SLE,SGP,SXM,SYR,SOM,LKA,SWZ,ZAF,SDN,SSD,SWE,CHE,SUR,SJM,THA,TWN,TZA,TJK,IOT,ATF,TLS,TGO,TKL,TON,TTO,TUN,TKM,TUR,TUV,UKR,UGA,URY,UZB,VUT,VAT,VEN,VNM,WLF,YEM,DJI,ZMB,ZWE,ZZZ'
      ],
      num_reg_id_trib: [
        'string',
        'min:1',
        'max:40'
      ],
      rfc: [
        'required',
        'string',
        'min:12',
        'max:13',
        'regex:/^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$/',
      ],
      curp: [
        'string',
        'size:18',
        'regex:/^[A-Z][AEIOUX][A-Z]{2}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[MH]([ABCMTZ]S|[BCJMOT]C|[CNPST]L|[GNQ]T|[GQS]R|C[MH]|[MY]N|[DH]G|NE|VZ|DF|SP)[BCDFGHJ-NP-TV-Z]{3}[0-9A-Z][0-9]$/',
      ],
      email: [
        'email',
        'min:3',
        'max:250'
      ],
      telefono: [
        'string',
        'min:8',
        'max:12'
      ],
      uso_cfdi: [
        'required'
      ],
      cp: [
        this.props.datos_fiscales_requeridos === true ? 'required' : 'string',
        'min:5',
        'max:5',
        'regex:/^[0-9]{5}$/'
      ],
      regimen: [
        'required', 'string'
      ]
    }
  }

  get regimenes() {
    const filtered = RegimenFiscalCatalog.map((item) => {
      return {
        label: `${item.descripcion} (${item.clave})`,
        value: item.clave
      }
    });

    const regimes = _.sortBy(filtered, 'label');

    return [{
      label: 'Selecciona Régimen Fiscal',
      value: ''
    }].concat(regimes);
  }

  get usoCfdi() {
    const { rfc, regimen } = this.props.data;

    const filtered = UsoDeCfdiCatalog.filter((item) => {
      if (!rfc) {
        return false;
      }

      if (rfc.length === 13) {
        return item.fisica === 'Sí' && (!regimen || !item.regimen || item.regimen.indexOf(regimen) !== -1);
      }

      return item.moral === 'Sí' && (!regimen || !item.regimen || item.regimen.indexOf(regimen) !== -1);
    }).map((item) => {
      return {
        label: `${item.descripcion} (${item.clave})`,
        value: item.clave
      }
    });

    const usoCfdi = _.sortBy(filtered, 'label');

    return [{
      label: 'Selecciona Uso de CFDI',
      value: ''
    }].concat(usoCfdi);
  }

  componentDidMount() {
    const { data } = this.props;

    if (!!data.rfc) {
      this.handleOnChange({});
    }
  }

  validate = (data) => {
    const validator = new Validator(data, this.rules);

    validator.check();

    if (data.rfc !== 'XEXX010101000') {
      data.residencia_fiscal = undefined;
      data.num_reg_id_trib = undefined;
    }

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step: this.props.step,
      isValid: validator.passes()
    });
  }

  render() {
    const { data = {}, autoFocus } = this.props;

    return (
      <Form autoComplete="off">

        <FormControl type="text"
          label="RFC"
          name="rfc"
          placeholder=""
          help=""
          casing={ 'upper' }
          minLength={ 12 }
          maxLength={ 13 }
          autoFocus={ autoFocus }
          rules={ this.rules.rfc }
          value={ data.rfc }
          onChange={ this.handleOnChange }
        />

        { data.rfc === 'XEXX010101000' && (
          <>
            <FormControl type="ahead"
              label="Residencia Fiscal"
              name="residencia_fiscal"
              placeholder=""
              help=""
              rules={ this.rules.residencia_fiscal }
              options={ CatalogoPais }
              value={ data.residencia_fiscal }
              onChange={ this.handleOnChange }
            />

            <FormControl type="text"
              label="Id Registro Tributario"
              name="num_reg_id_trib"
              placeholder=""
              help=""
              rules={ this.rules.num_reg_id_trib }
              value={ data.num_reg_id_trib }
              onChange={ this.handleOnChange }
            />
          </>
        )}

        <FormControl type="text"
          label="Razón social"
          name="razon_social"
          placeholder=""
          help=""
          rules={ this.rules.razon_social }
          value={ data.razon_social }
          onChange={ this.handleOnChange }
        />

        { !this.props.autofacturacion && (
          <FormControl type="text"
            label="CURP"
            name="curp"
            placeholder=""
            help=""
            casing={ 'upper' }
            rules={ this.rules.curp }
            value={ data.curp }
            onChange={ this.handleOnChange }
          />
        )}

        <FormControl type="text"
          label="Email"
          name="email"
          placeholder="email@example.com"
          help=""
          rules={ this.rules.email }
          value={ data.email }
          onChange={ this.handleOnChange }
        />

        { !this.props.autofacturacion && (
          <FormControl type="number"
            label="Teléfono"
            name="telefono"
            help=""
            rules={ this.rules.telefono }
            value={ data.telefono }
            onChange={ this.handleOnChange }
          />
        )}

        <FormControl type="select"
          label="Régimen fiscal"
          name="regimen"
          placeholder=""
          help=""
          rules={ this.rules.regimen }
          value={ data.regimen }
          options={ this.regimenes }
          onChange={ this.handleOnChange }
        />

        <FormControl type="select"
          label="Uso de CFDI"
          name="uso_cfdi"
          placeholder=""
          help=""
          rules={ this.rules.uso_cfdi }
          value={ data.uso_cfdi }
          options={ this.usoCfdi }
          onChange={ this.handleOnChange }
        />

        { [true, false].indexOf(this.props.datos_fiscales_requeridos) !== -1 && (
          <FormControl type="text"
            label="Código Postal"
            name="cp"
            placeholder=""
            help=""
            minLength="5"
            maxLength="5"
            rules={ this.rules.cp }
            value={ data.cp }
            onChange={ this.handleOnChange }
          />
        )}

      </Form>
    )
  }
}

export default ReceptorFiscalInfoForm;